// @ts-nocheck
(() => {
  const STORAGE_KEY = "mte_wishlist";

  function getWishlist() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error("No se pudo leer la wishlist:", error);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.error("No se pudo guardar la wishlist:", error);
    }
  }

  function getProductFromButton(button) {
    return {
      handle: button.dataset.productHandle || "",
      title: button.dataset.productTitle || "",
      url: button.dataset.productUrl || "",
      price: button.dataset.productPrice || "",
      image: button.dataset.productImage || "",
      vendor: button.dataset.productVendor || "",
      variantId: button.dataset.variantId || "",
      available: button.dataset.productAvailable === "true",
    };
  }

  function isFavorite(handle, wishlist) {
    return wishlist.some((item) => item.handle === handle);
  }

  function updateButton(button, active) {
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
    button.setAttribute(
      "aria-label",
      active ? "Quitar producto de favoritos" : "Agregar producto a favoritos"
    );
    button.setAttribute(
      "title",
      active ? "Quitar de favoritos" : "Agregar a favoritos"
    );
  }

  function updateCounters(count) {
    document.querySelectorAll("[data-mte-wishlist-count]").forEach((counter) => {
      counter.textContent = count;
      counter.hidden = count === 0;
    });
  }

  function updateAllButtons() {
    const wishlist = getWishlist();

    document
      .querySelectorAll("[data-mte-wishlist-button]")
      .forEach((button) => {
        updateButton(
          button,
          isFavorite(button.dataset.productHandle, wishlist)
        );
      });

    updateCounters(wishlist.length);
  }

  function toggleProduct(button) {
    const product = getProductFromButton(button);

    if (!product.handle) return;

    const wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(
      (item) => item.handle === product.handle
    );

    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
      updateButton(button, false);
    } else {
      wishlist.push(product);
      updateButton(button, true);
    }

    saveWishlist(wishlist);
    updateCounters(wishlist.length);

    document.dispatchEvent(
      new CustomEvent("mte:wishlist-updated", {
        detail: {
          wishlist,
          count: wishlist.length,
        },
      })
    );
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-mte-wishlist-button]");

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleProduct(button);
  });

  document.addEventListener("DOMContentLoaded", updateAllButtons);
  document.addEventListener("shopify:section:load", updateAllButtons);

  window.MTEWishlist = {
    get: getWishlist,
    save: saveWishlist,
    refresh: updateAllButtons,
  };
})();